<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="送货日期：">
            <el-date-picker size="medium" v-model="searchForm.date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
              :clearable="false" style="width: 200px"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="handleCurrentChange(1)" style="float:right">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
        <el-tab-pane v-for="(item, index) in kindList" :label="item.CATALOG_NAME" :key="index"
          :name="item.CATALOG_NAME">
        </el-tab-pane>
        <div class="el-tabs__content">
          <el-table :data="tableData" border style="width: 100%" :span-method="objectSpanMethod"
            :row-class-name="tableRowClassName">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
            <el-table-column prop="NAME" label="名称"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
            <el-table-column prop="PRODUCT_COUNT" label="需出库数量"></el-table-column>
            <el-table-column prop="BATCH" label="批次">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.BATCH }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="IW_PRODUCT_COUNT" label="库存">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.IW_PRODUCT_COUNT }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="OUT_PRODUCT_COUNT" label="实际出库数量">
              <template slot-scope="scope">
                <el-input v-model="scope.row.OUT_PRODUCT_COUNT"></el-input>
              </template>
            </el-table-column>
            <el-table-column width="150px">
              <template slot-scope="scope">
                <el-button v-if="scope.row.NOW_COUNT == 0" type="text" @click="openMatch(scope.row)">匹配</el-button>
                <el-button :disabled="true" v-if="scope.row.NOW_COUNT !== 0" type="text">匹配</el-button>
                <el-button type="text" @click="openCharge(scope.row)">拆箱</el-button>
                <el-button type="text" @click="openAdd(scope.row)">合箱</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button style="float: right;margin-top: 20px" @click="submitOutWare">确认出库</el-button>
        </div>
      </el-tabs>
    </el-row>
    <!-- 匹配库存剩余产品 -->
    <el-dialog :visible.sync="matchProductDialog" title="修改匹配产品" @close="matchProductDialog = false" width="400px"
      center :close-on-click-modal="false">
      <el-form inline ref="matchProductForm" :model="matchProductForm">
        <el-form-item label='产品名称：' prop="Name">
          <el-select filterable v-model="matchProductForm.CODE" placeholder="请选择" :clearable="true">
            <el-option v-for="item in matchProductList" :key="item.PRODUCT_CODE" :label="item.PRODUCT_NAME"
              :value="item.PRODUCT_CODE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="换算比例：">
          <el-input v-model="matchProductForm.BUY_RATE" style="width: 220px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="matchProductDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitMatch('matchProductForm')">确认</el-button>
      </div>
    </el-dialog>
    <!-- 出库为0的条目 -->
    <el-dialog :visible.sync="infoDialog" title="以下产品出库数量为0,确认出库吗?" @close="infoDialog = false" width="600px" center
      :close-on-click-modal="false">
      <el-table :data="infoData" border stripe>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="NAME" label="名称"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="IW_PRODUCT_COUNT" label="出库数量"></el-table-column>
      </el-table>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="infoDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitOut('matchProductForm')">确认</el-button>
      </div>
    </el-dialog>
    <!-- 拉取可拆箱的产品 -->
    <el-dialog title="请选择可拆箱的产品" center :visible.sync="sperateListVisible" width="600px">
      <el-table :data="sperateList" stripe border>
        <el-table-column prop="NAME" label="名称"></el-table-column>
        <el-table-column prop="SUB_TYPE_COUNT" label="合箱比例"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="BATCH" label="批次号"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="库存数量"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="openSperateBox(scope.row)">立即拆箱</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 拆箱 -->
    <el-dialog title="拆箱" center :visible.sync="unpackingVisible" width="600px">
      <el-form :model="addForm" ref="addForm" size="small">
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <span>{{ addForm.NAME }}</span>
        </el-form-item>
        <el-form-item label="库存数量：" :label-width="formLabelWidth">
          <span>{{ addForm.NOW_COUNT }}</span>
        </el-form-item>
        <el-form-item label="拆箱数量：" :label-width="formLabelWidth">
          <el-input v-model="addForm.CXCOUNT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="submitUnpack">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 拉取可合箱的产品 -->
    <el-dialog title="请选择需要合箱后的目标产品" center :visible.sync="addListVisible" width="600px">
      <el-table :data="addBoxList" stripe border>
        <el-table-column prop="NAME" label="名称"></el-table-column>
        <el-table-column prop="SUB_TYPE_COUNT" label="合箱比例"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="BATCH" label="批次号"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="库存数量"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="openAddBox(scope.row)">立即合箱</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 合箱 -->
    <el-dialog title="合箱" center :visible.sync="addBoxVisible" width="450px">
      <el-form :model="addBoxForm" ref="addBoxForm" size="small">
        <el-form-item label="合箱数量：" :label-width="formLabelWidth">
          <el-input v-model="addBoxForm.COUNT" style="width: 200px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addBoxVisible = false">取 消</el-button>
        <el-button size="small" @click="submitAddBox">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getMTOKindFun, queryMTStable, submitOutFun, queryMatchFun, unpackingFun, addBoxFun, wareBoxListFun, wareSperateListFun,
} from 'api/warehouseManager';
import { getFormatDay } from '@/assets/common/common';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {
        date: getFormatDay(0, '-'),
      },
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      kindList: [],
      activeName: '',
      position: 0,
      positionSto: 0,
      spanArr: [],
      catalogId: 0,
      matchProductDialog: false,
      matchProductForm: {},
      matchProductList: [],
      infoDialog: false,
      infoData: [],
      unpackingVisible: false,
      addForm: {},
      formLabelWidth: '110px',
      addBoxVisible: false,
      addBoxForm: {},
      addListVisible: false,
      addBoxList: [],
      sperateList: [],
      sperateListVisible: false,
    };
  },
  methods: {
    queryKind() {
      const params = {
        OW_TYPE: 2,
        SEND_DAY: this.searchForm.date,
      };
      getMTOKindFun(params).then((result) => {
        if (result.length !== 0) {
          this.kindList = result;
          this.activeName = result[0].CATALOG_NAME;
          this.queryTable(result[0].ID);
          this.catalogId = result[0].ID;
        } else {
          this.kindList = [];
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleClick(tab, event) {
      this.tableData = [];
      const submitID = this.kindList.filter((item) => {
        if (item.CATALOG_NAME == tab.label) {
          return item;
        }
      });
      this.activeName = tab.label;
      this.queryTable(submitID[0].ID);
      this.catalogId = submitID[0].ID;
    },
    queryTable(e) {
      const params = {
        SEND_DAY: this.searchForm.date,
        PAGESIZE: this.pageSize,
        CATALOG_ID: e,
      };
      queryMTStable(params).then((result) => {
        if (result[0]) {
          this.tableData = result.map((item) => {
            if (item.OUT_PRODUCT_COUNT) {
              return Object.assign(item, { NOW_COUNT: item.IW_PRODUCT_COUNT });
            }
            item.OUT_PRODUCT_COUNT = 0;
            return Object.assign(item, { NOW_COUNT: item.IW_PRODUCT_COUNT });
          });
          this.rowspan();
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitOutWare() {
      const arrFilter = this.tableData.filter((item) => item.IW_PRODUCT_COUNT == 0);
      if (arrFilter.length == 0) {
        this.submitOut();
      } else {
        this.infoData = arrFilter;
        this.infoDialog = true;
      }
    },
    submitOut() {
      const tmpArr = this.tableData.map((item, index) => ({ BATCH: item.BATCH, DELIVER_COUNT: Number(item.OUT_PRODUCT_COUNT) }));
      // let submitArr = tmpArr.filter(item => item.DELIVER_COUNT !== 0)
      const params = {
        SEND_DAY: this.searchForm.date,
        PRODUCT_ARRAY: tmpArr,
        CATALOG_ID: this.catalogId,
        OW_TYPE: 2,
      };
      // this.loading1 = true
      submitOutFun(params).then((result) => {
        this.$message.show({ text: '提交成功', type: 'success' });
        this.queryKind();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      // this.queryTable(e-1)
      this.queryKind();
    },
    openMatch(row) {
      this.matchProductDialog = true;
      this.matchProductForm.PRODUCT_CODE = row.PRODUCT_CODE;
      this.queryMatchProduct();
    },
    // 拉取可匹配产品
    queryMatchProduct() {
      const params = {};
      queryMatchFun(params).then((result) => {
        this.matchProductList = result.map((item) => Object.assign(item, { PRODUCT_NAME: `${item.NAME}(${item.TYPE_UNIT})` }));
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 提交匹配
    submitMatch() {
      const params = {
        SERVICE_ID: '10050',
        OTYPE: 12,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        BUYED_PRODUCT_CODE: this.matchProductForm.CODE,
        PRODUCT_CODE: this.matchProductForm.PRODUCT_CODE,
        BUY_RATE: this.matchProductForm.BUY_RATE,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.matchProductDialog = false;
        this.queryKind();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 拆箱
    openCharge(row) {
      const params = {
        PRODUCT_CODE: row.PRODUCT_CODE,
      };
      wareSperateListFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.sperateList = result;
            this.sperateListVisible = true;
          } else {
            this.$message.show({ text: '暂无配置信息', type: 'error' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    openSperateBox(row) {
      this.unpackingVisible = true;
      this.addForm = row;
    },
    close() {
      this.unpackingVisible = false;
    },
    submitUnpack() {
      const params = {
        BATCH: this.addForm.BATCH,
        PRODUCT_CODE: this.addForm.SRC_CODE,
        PRODUCT_NUMBER: Number(this.addForm.CXCOUNT),
      };
      unpackingFun(params)
        .then((result) => {
          this.$message.show({ text: '拆箱成功', type: 'success' });
          this.unpackingVisible = false;
          this.sperateListVisible = false;
          this.queryKind();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 合箱
    openAdd(row) {
      const params = {
        PRODUCT_CODE: row.PRODUCT_CODE,
      };
      wareBoxListFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.addBoxList = result;
            this.addListVisible = true;
          } else {
            this.$message.show({ text: '暂无配置信息', type: 'error' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    openAddBox(row) {
      this.addBoxVisible = true;
      this.addBoxForm = row;
    },
    submitAddBox() {
      const params = {
        BATCH: this.addBoxForm.BATCH,
        PRODUCT_CODE: this.addBoxForm.SUB_CODE,
        PRODUCT_NUMBER: Number(this.addBoxForm.COUNT),
        ABOVE_PRODUCT_CODE: this.addBoxForm.DEST_CODE,
      };
      addBoxFun(params)
        .then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.addBoxVisible = false;
          this.addListVisible = false;
          this.queryKind();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.IW_PRODUCT_COUNT == 0) {
        return 'success-row';
      }
      return '';
    },
    // --------------------------行
    rowspan() {
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr = [];
          this.spanArr.push(1);
          this.position = 0;
        } else if (this.tableData[index].ID === this.tableData[index - 1].ID) {
          this.spanArr[this.position] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.position = index;
        }
      });
    },
    // ---------------------------------表格合并行
    objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    // this.queryTable()
    this.queryKind();
  },
};
</script>
<style>
.el-table .success-row {
  background: #fa7a7a;
}

.el-table .warning-row {
  background: oldlace;
}


</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/totalMTSOut.vue